import { render } from "./Wallets.vue?vue&type=template&id=c95cc9be"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"

import "./Wallets.vue?vue&type=style&index=0&id=c95cc9be&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__